import { z } from 'zod';
import { dateField, nullableDateField } from '@shared/schemas';
import { latLonSchema } from './ILatLon';
import { ProjectPackageTypeEnum } from './ProjectPackageType.enum';
// Schemas (source of truth)
export const workDayHoursSchema = z.object({
	startDayTime: z.string().nullable().optional(),
	endDayTime: z.string().nullable().optional(),
	dailyWorkerHours: z.number(),
});

export const responsibleManagerSchema = z.object({
	name: z.string(),
	mail: z.string(),
	phone: z.string().optional(),
});

export const projectSchema = z.object({
	_id: z.string(),
	name: z.string(),
	organizationId: z.string(),
	city: z.string(),
	countryShortName: z.string().optional(),
	projectId: z.string(),
	isEnabled: z.boolean(),
	language: z.string(),
	workDayHours: z.array(workDayHoursSchema),
	centerLocation: latLonSchema.optional(),
	tz: z.string(),
	startDate: nullableDateField.optional(),
	endDate: nullableDateField.optional(),
	expectedDailyWorkforce: z.number().default(0),
	responsibleManager: responsibleManagerSchema.optional(),
	isExecutiveViewEnabled: z.boolean().optional(),
	isDemo: z.boolean().optional(),
	packageType: z.enum(ProjectPackageTypeEnum),
	orderIndex: z.number().nullable().optional(),
});

// Types (derived from schemas)
export type IWorkDayHours = z.infer<typeof workDayHoursSchema>;
export type IProject = z.infer<typeof projectSchema>;

export interface IProjectReducerState {
	workingProject?: IProject;
	userProjects?: IProject[];
}
